<template>
  <Layout @componentKey="gotRefresh" @currentPage="currentPage" :hasPagination="true" :hasBreadcrumbs="true" :amount="amount.aantal" :amountToShow="amountToShow" :openModalHandler="openModalHandler">
    <div class="content">
      <div class="page-content" ref="tableContent">
        <MainTitle :title="this.$router.currentRoute.name"  />
        <TableFilter @selectedFilter="gotFilter" :currentFilter="this.filter" :filters="[{'name': 'DB'},{'name': 'OS'},{'name': 'OSP'},{'name': 'OBA'},{'name': 'DIS'},{'name': 'INSTR'},{'name': 'OEM'},{'name': 'OTHER'}]" :hasAllButton="true" />
        <DevicesTable @selectedAmount="gotAmountToShow" @selectedRow="gotDevice" :devices="this.devices" :totalItems="amount.aantal" @sorting="gotSorting"  @refresh="gotRefresh"/>
      </div>
      <div class="sidebar">
        <TableAction :hasButton="this.userDetails.isAdmin == 1 ? true : false" @clickedButton="gotClick" title="Add Device" :isAdd="true"/>
        <TableDetail v-if="this.selectedDevice"  height="44" :details="this.selectedDevice" @refresh="gotRefreshPageData" />
        <TableDetailCustom v-if="this.selectedDevice && this.selectedDevice.type =='assembly'" :details="this.selectedDevice" @refresh="gotRefreshPageData" />
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import Loading from "@/components/base/Loading";
import DevicesTable from "@/components/TblDevices";
import TableAction from "@/components/TableAction";
import TableDetail from "@/components/TblDeviceDetail";
import TableDetailCustom from "@/components/TblDeviceDetailCustom";
import MainTitle from "@/components/base/MainTitle";
import TableFilter from "@/components/base/TableFilter";

export default {
  name: "management-devices",
  props: {
    compKey: Number
  },
  computed: {
    maxRows: function () {
      let heightContent = this.$refs.tableContent.clientHeight;
      let heightSingleRow = 76

      return Math.ceil(heightContent / heightSingleRow) - 2
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  data () {
    return {
      isLoading: true,
      devices: null,
      amount: 0,
      selectedDevice: null,
      pagina: 1,
      openModalHandler: false,
      sortingOn: "ref",
      isAscending: true,
      filter: 'all',
      amountToShow: 8
    }
  },
  components: {
    Layout,
    Loading,
    TableFilter,
    DevicesTable, 
    MainTitle, 
    TableAction,
    TableDetail,
    TableDetailCustom
  },
  mounted() {
    this.amountToShow = this.maxRows
    this.getData()
  },
  methods: {
    gotAmountToShow(val) {
      if(val == 9) {
        this.amountToShow = this.maxRows
      } else {
        this.amountToShow = parseInt(val)
      }

      this.pagina = Math.ceil(this.amount.aantal / parseInt(val))
      this.getData()
    },
    getData() {
      var that = this
      let offset = this.pagina != 1 ? (this.pagina * this.amountToShow) - this.amountToShow : 0
      let asc = this.isAscending ? "A" : "D"
      this.$http.get(this.$endpoint + 'management/devices/' + this.filter + '/' + this.sortingOn + '/' + asc + '/' + this.amountToShow + '/' + offset)
      .then(response => {
        console.log(response)
        that.amount = response.data.pop()
        that.devices = response.data
        that.selectedDevice = null

        switch(this.sortingOn) {
          case 'ref':
            if(this.isAscending) {
              that.devices.sort((a, b) => (a.ref > b.ref) ? 1 : -1)
            } else {
              that.devices.sort((a, b) => (a.ref < b.ref) ? 1 : -1)
            }
            break;
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        } else {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }, THIS IS PROBABLY BECAUSE THERE ARE NO RECORDS`,
            'error'
          );
        }
      })
    },
    currentPage(page) {
      this.pagina = page
    },
    gotSorting(sort) {
      this.isAscending = sort.asc
      this.sortingOn = sort.on
      this.getData()
    },
    gotDevice(mat) {
      this.selectedDevice = mat // someValue
    },
    gotFilter(filter) {
      this.filter = filter
    },
    gotClick(val) {
      this.openModalHandler = !this.openModalHandler;
    },
    gotRefresh(val) {
      this.pagina = 1
      this.amount = 0
      this.getData()
    },
    gotRefreshPageData(val) {
      this.amount = 0
      this.getData()
    }
  },
  watch: {
    pagina: function (val) {
      this.getData()
    },
    amount: function (newVal, oldVal) {
      if(newVal.aantal != oldVal && newVal.aantal != oldVal.aantal && oldVal != 0) {
        this.getData()
      }
    } ,
    filter: function (val) {
      this.pagina = 1
      this.getData()
    } 
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;
